import React, { useCallback, useContext, useMemo } from 'react';
import { DateTime } from 'luxon';
import { SystemIcon } from '@storeblocks/icon';
import CalendarContext from '../CalendarContext';
import Square from '../Square';
import { FooterBase } from './styled';
const sortRange = (range) => range.sort((a, b) => a.getTime() - b.getTime());
function FooterRange() {
    const { min, max, locale, setView, setDate, range, setRange, onRangeChange, disabledDate, clearable, clearLabel, } = useContext(CalendarContext);
    const isTodayDisabled = useMemo(() => DateTime.now().startOf('day') > DateTime.fromJSDate(max) ||
        DateTime.now().endOf('day') < DateTime.fromJSDate(min) ||
        disabledDate(DateTime.now().toJSDate()), [min, max, disabledDate]);
    const [firstRangeDate, secondRangeDate] = useMemo(() => range, [range]);
    const addTodayToRange = useCallback(() => {
        const today = DateTime.now().startOf('day');
        const isSelectingFirstDate = !firstRangeDate || (firstRangeDate && secondRangeDate);
        const isSelectingSecondDate = !!firstRangeDate && secondRangeDate === null;
        const isFirstDateSameAsCurrent = firstRangeDate &&
            today.toISODate() ===
                DateTime.fromJSDate(firstRangeDate).startOf('day').toISODate();
        setDate(today);
        if (isSelectingFirstDate) {
            setRange([today.toJSDate(), null]);
            return;
        }
        if (isFirstDateSameAsCurrent) {
            return;
        }
        if (isSelectingSecondDate) {
            const newValidRange = sortRange([firstRangeDate, today.toJSDate()]);
            setRange(newValidRange);
            onRangeChange(newValidRange);
        }
    }, [firstRangeDate, secondRangeDate, setRange, setDate, onRangeChange]);
    const todayButton = useMemo(() => {
        if (isTodayDisabled)
            return null;
        return (React.createElement(Square, { px: "16px", onClick: () => {
                setView('day');
                addTodayToRange();
            } },
            React.createElement("span", null, DateTime.now().setLocale(locale).toRelativeCalendar()),
            React.createElement(SystemIcon, { name: "arrow-right", size: 16 })));
    }, [locale, isTodayDisabled, setView, addTodayToRange]);
    const clearButton = useMemo(() => {
        if (!clearable)
            return null;
        return (React.createElement(Square, { mr: "8px", px: "16px", onClick: () => {
                setView('day');
                setRange([null, null]);
                onRangeChange(undefined);
            } },
            React.createElement("span", null, clearLabel),
            React.createElement(SystemIcon, { name: "close", size: 16 })));
    }, [clearable, clearLabel, onRangeChange, setRange, setView]);
    return ((clearable || !isTodayDisabled) && (React.createElement(FooterBase, null,
        clearButton,
        todayButton)));
}
export default FooterRange;
